const initialState = {
  cookiePolicyState: null
};

export default function applicationReducer(state = initialState, action) {
  switch (action.type) {
    case 'ACCEPT_COOKIE_POLICY':
      return { ...state, cookiePolicyState: 'accepted' };

    case 'REJECT_COOKIE_POLICY':
      return { ...state, cookiePolicyState: 'rejected' };
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/browser/application/reducer.js